import './Control.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import Mapir from "mapir-react-component";
import { MenuBottomGeo } from "./MenuBottomGeo";
import { mapApiKey } from "../config.json";
import { toast } from "react-toastify";

export class Control extends Component {
    static displayName = Control.name;
    state = {

    };


    componentDidMount() {
        let choice = cardService.getChoiceCard();
        console.log('choiceddd', choice);
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است')
            this.props.history.replace({ pathname: '/main' });
            return;
        }
        this.setState({ choiceDevice: choice });

    }

    doItem = (e, state) => {
        e.preventDefault();
        if (state == 1)
            utils.sendSms(this.state.choiceDevice.deviceNumber, `lock`);
        else if (state == 2)
            utils.sendSms(this.state.choiceDevice.deviceNumber, `unlock`)
        else if (state == 3)
            utils.sendSms(this.state.choiceDevice.deviceNumber, `trunk`)
        else if (state == 4)
            utils.sendSms(this.state.choiceDevice.deviceNumber, `mute`)
        toast.dark('لطفا تا دریافت پیام از دستگاه صبر کنید');

    }

    render() {

        return (
            <>

                <div className="container-fluid">
                    <div className="row" >
                        <div className="col justify-content-center" id="parentCol">
                            <div className=" " id="parentControl">
                                <div className="row">
                                    <div className="col justify-content-center d-flex">
                                        <button className="btn" onClick={(e) => this.doItem(e, 1)}>
                                            <img src="images/lock.png" />
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col justify-content-center d-flex">
                                        <button className="btn  " onClick={(e) => this.doItem(e, 2)}>
                                            <img src="images/unlock.png" />
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col justify-content-center d-flex">
                                        <button className="btn  " onClick={(e) => this.doItem(e, 3)}>
                                            <img src="images/dooropen.png" />
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col justify-content-center d-flex">
                                        <button className="btn  " onClick={(e) => this.doItem(e, 4)}>
                                            <img src="images/soundOff.png" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <MenuBottomGeo />
            </>

        );
    }


}